import { generateTitles } from 'backend/titles-generator-wrapper.jsw'
import { copyToClipboard } from 'wix-window';
import { session } from 'wix-storage';
import { biLoggerFactory } from 'wix-private';
import { BIEventsIDs } from 'public/constants.js';

const biLogger = biLoggerFactory('blog-tg', 19, { msid: '05eb856c-0c11-4619-98e1-3cf524053998' });
let generatedTitles = [];
let isNewSearch = true;
let debounceTimer;
let prevSearchTerm = '';

$w.onReady(function () {
    initPageEvents();
});

function initPageEvents() {

    const isStickySearchRendered = $w('#stickySearchContainer') && $w('#stickySearchContainer').rendered;

    isStickySearchRendered && $w('#mainSearchContainer').onViewportLeave(() => {
        $w('#stickySearchContainer').show();
    }).onViewportEnter(() => {
        $w('#stickySearchContainer').hide();
    });

    $w('#infoIcon').onMouseIn(() => {
        $w('#infoBox').show();
    }).onMouseOut(() => {
        $w('#infoBox').hide();
    });

    isStickySearchRendered && $w('#stickyInfoIcon').onMouseIn(() => {
        $w('#stickyInfoBox').show();
    }).onMouseOut(() => {
        $w('#stickyInfoBox').hide();
    });

    isStickySearchRendered && $w('#stickyShowTitlesBtn').onClick(() => {
        $w('#mainSearchInput').value = $w('#stickySearchInput').value;
        $w('#mainSearchContainer').scrollTo();
        getTitles();
    })
    $w('#showTitlesBtn').rendered && $w('#showTitlesBtn').onClick(() => {
        if (isStickySearchRendered) {
            $w('#stickySearchInput').value = $w('#mainSearchInput').value;
        }
        getTitles();
        $w('#mainSearchContainer').scrollTo();
    });

    $w('#showTitlesMobBtn').rendered && $w('#showTitlesMobBtn').onClick(() => {
        getTitles();
        $w('#mainSearchContainer').scrollTo();
    });
    isStickySearchRendered && $w('#stickySearchInput').onKeyPress(event => {
        const searchTerm = $w('#stickySearchInput').value;
        if (event.key === "Enter") {
            if (prevSearchTerm !== searchTerm) {
                clearSessionStorage();
                prevSearchTerm = searchTerm;
            }
            $w('#mainSearchContainer').scrollTo();
            $w('#mainSearchInput').value = searchTerm;
            getTitles();
        }
        if (debounceTimer) {
            clearTimeout(debounceTimer);
            debounceTimer = undefined;
        }
        debounceTimer = setTimeout(() => {
            fireBIEvent(0, { searchTerm });
        }, 10000);
    })
    $w('#mainSearchInput').onKeyPress(event => {
        const searchTerm = $w('#mainSearchInput').value;
        if (event.key === "Enter") {
            if (prevSearchTerm !== searchTerm) {
                clearSessionStorage();
                prevSearchTerm = searchTerm;
            }
            if (isStickySearchRendered) {
                $w('#stickySearchInput').value = searchTerm;
            }
            getTitles();
        }
        if (debounceTimer) {
            clearTimeout(debounceTimer);
            debounceTimer = undefined;
        }
        debounceTimer = setTimeout(() => {
            fireBIEvent(0, { searchTerm });
        }, 10000);
    });
    $w('#titlesRepeater').onItemReady(($item, itemData) => {
        $item('#title').text = itemData.title;
        $item('#copyIcon') && $item('#copyIcon').rendered && $item('#copyIcon').onMouseIn(() => {
            $item('#copyText').text = 'Copy your title to your blog';
            $item('#copyBox').show();
        });
        $item('#copyIcon') && $item('#copyIcon').rendered && $item('#copyIcon').onMouseOut(() => {
            $item('#copyBox').hide();
        });
        $item('#copyIcon') && $item('#copyIcon').rendered && $item('#copyIcon').onClick(() => {
            try {
                const toCopyTitle = itemData.title;
                // fire copyto clipboard BIEvent
                fireBIEvent(4, { titleName: toCopyTitle });
                copyToClipboard(toCopyTitle);
                $item('#copyText').text = 'Copied to clipboard';
                $item('#copyBox').show();
                setTimeout(() => {
                    $item('#copyBox').hide();
                    $item('#copyText').text = 'Copy your title to your blog';
                }, 500);
            } catch (err) {
                console.error(`error copying item to the Clipboard due to: ${err.message} `)
            }
        });
    });

    $w('#categoryDropdownBtn').onClick(() => {
        // fire open refine dropdown BIEvent
        fireBIEvent(2);
        $w('#categoryOptionsBox').expand();
    })
    $w('#categoryOptionsBox').onMouseOut(() => {
        $w('#categoryOptionsBox').collapse();
    })

    const categoryOptionsBtn = $w('#categoryOptionsBox').children;
    categoryOptionsBtn.forEach(btn => {
        btn.onClick(() => {
            const category = btn.label;
            fireBIEvent(3, { category });
            let categoryValue;
            switch (category) {
            case 'Place':
                categoryValue = 'LOCATION';
                break;
            case 'Product':
                categoryValue = 'CONSUMER_GOOD';
                break;
            case 'Other':
                categoryValue = 'SINGULAR_NOUN';
                break;
            default:
                categoryValue = category.toUpperCase();
                break;
            }
            getTitles(categoryValue);
            $w('#categoryDropdownBtn').label = category;
            $w('#categoryOptionsBox').collapse();
        })
    })

    $w('#loadMoreBtn').onClick(() => {
        const ctaName = $w('#loadMoreBtn').label;
        // fire loadMore click BIEvent
        fireBIEvent(5);
        //fire secondary cta click BI event 
        fireBIEvent(7, { ctaName, ctaUrl: '' });

        setTitlesRepeaterData();
    })
    secondaryCTAClickHandler();

}

async function getTitles(category = '') {
    let searchTerm = $w('#mainSearchInput').value;
    let storedEntity = '';
    if (!searchTerm) {
        $w('#mainSearchInput').required = true;
        return;
    }
    if (!category) {
        $w('#categoryDropdownBtn').label = 'Optional';
    }
    isNewSearch = true;
    $w('#loader').show();
    $w('#resultStrip').isVisible && $w('#resultStrip').collapse();
    $w('#titlesRepeater').data = [];
    try {
        const storedTerm = session.getItem('term');
        if (storedTerm && storedTerm.toLowerCase() === searchTerm.toLowerCase()) {
            storedEntity = session.getItem('entity')
            searchTerm = storedTerm;
        } else {
            clearSessionStorage();
        }
        const generateTitlesResult = await generateTitles({ searchTerm, category, prevEntity: storedEntity }) || [];
        const { titles = [], gsearchTerm = '', entity = '' } = generateTitlesResult || {};
        session.setItem("term", gsearchTerm);
        session.setItem('entity', entity);
        generatedTitles = titles;
        const numOfTitles = generatedTitles.length;
        if (numOfTitles > 0) {
            //fire Search BI
            fireBIEvent(1, { category, numResults: numOfTitles, searchTerm });
            setTitlesRepeaterData();
        } else {
            throw new Error('Sorry no titles found');
        }
    } catch (err) {
        //show error message for user / To-Do add empty state 
        $w('#loader').hide();
        console.error(err);
    }
}

function setTitlesRepeaterData() {
    const prevLoadedTitles = $w('#titlesRepeater').data;
    const newLoadedTitles = generatedTitles.splice(0, 7);
    const newLoadedTitleswithIds = newLoadedTitles.map((title) => {
        return { title: title, '_id': Math.random().toString().replace('.', '') };
    });
    $w('#titlesRepeater').data = [...prevLoadedTitles, ...newLoadedTitleswithIds];
    if (isNewSearch) {
        $w('#resultStrip').expand();
        $w('#titlesRepeater').show();
        $w('#loadMoreBtn').enable();
        $w('#loadMoreBtn').show();
        $w('#loader').hide();
    }
    if (generatedTitles.length === 0) {
        $w('#loadMoreBtn').disable();
    }
}

function secondaryCTAClickHandler() {
    const secondaryCTAs = ['goodHL', 'promote', 'writePost', 'createBlog', 'measureTraffic', 'learnMore', 'startABlog', 'startBlogging'];
    secondaryCTAs.forEach(cta => {
        $w(`#${cta}Box`).onClick(() => {
            const ctaName = $w(`#${cta}Btn`).label;
            const ctaUrl = $w(`#${cta}Btn`).link;
            fireBIEvent(7, { ctaName, ctaUrl });
        });
    });
}

function clearSessionStorage() {
    session.removeItem('term');
    session.removeItem('entity');
}

function fireBIEvent(evidIndex, params) {
    const evid = BIEventsIDs[evidIndex];
    try {
        const biEventObject = {
            evid,
            ...params
        };
        biLogger.log(biEventObject);
    } catch (err) {
        console.error(`errSrc: Public/BIEventsFunctions - fireBIEvent, err: ${err}`);
    }

}